export default __webpack_public_path__ + "static/media/news-logo.c5d8e35e.svg";